function useStyles() {
    return {
        userContent: {
            display: 'flex',
            alignItems: ''
        },
        container: {
            height: '540px',
            overflow: 'auto'
        }
    }
}

export { useStyles }